export default {
  verifyTwoFactory() {
    return state.VerifyTwoFactory;
  },
};
